import React from 'react'
import { Helmet } from 'react-helmet-async'
import TopBanner from '../components/top-banner'
import Navbar from '../components/navbar'
import CancellationPolicy from '../components/cancellation-policy'
import Footer from '../components/footer'
import SocialMediaFixed from '../components/socialmedia-fixed'

const CancellationPolicyPage = () => {
    return (
        <>
            <Helmet>
                <title>Cancellation Policy - Vanasthali Jungle Resort</title>
                <meta name="description" content="Learn about the cancellation policy for bookings at Vanasthali Jungle Resort. Know the terms, deadlines, and conditions for modifying or canceling your reservation." />
                <meta name="keywords" content="Vanasthali Jungle Resort cancellation policy, resort booking cancellation terms, cancellation policy, Corbett resort cancellation, Vanasthali Jungle Resort booking rules" />
                <link rel="canonical" href="https://vanasthalicorbett.com/cancellation-policy" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Hotel",
                        "name": "Vanasthali Jungle Resort",
                        "url": "https://vanasthalicorbett.com/cancellation-policy",
                        "telephone": "+91 8743000197"

                    })}
                </script>
            </Helmet>




            {<TopBanner />}
            {<Navbar />}
            {<CancellationPolicy />}
            {<Footer />}
            {<SocialMediaFixed />}
        </>
    )
}

export default CancellationPolicyPage
